import { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { removeNonDigitCharacters } from "shared/utils";

import InputFilter from "features/ui/Filters/FilterTypes/InputFilter";
import { onlyAllowPositiveIntegersOnKeyDown } from "features/ui/Filters/utils";

import {
  DURATION_FIELDS,
  DurationUnit,
  getValueFromDuration,
  setValueToDuration,
} from "./utils";

interface Props {
  fieldName: string;
  value: string;
  disabled?: boolean;
  onChange: (duration: string) => void;
  autoFocus?: boolean;
}

const DurationFilter = ({
  fieldName,
  value,
  disabled,
  onChange,
  autoFocus,
}: Props) => {
  const { t } = useTranslation("filters");

  const onKeyDown = (event: KeyboardEvent) =>
    onlyAllowPositiveIntegersOnKeyDown(event);

  const handleChange =
    (unit: DurationUnit) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newDuration = setValueToDuration(
        value,
        unit,
        removeNonDigitCharacters(e.target.value)
      );

      onChange(newDuration);
    };

  return (
    <div className="flex space-x-2 items-center">
      {DURATION_FIELDS.map(({ name }) => (
        <InputFilter
          autoFocus={autoFocus}
          key={name}
          fieldName={`${fieldName}-${name}`}
          type="number"
          value={getValueFromDuration(value, name)}
          onKeyDown={onKeyDown}
          onChange={handleChange(name)}
          slotProps={{ htmlInput: { min: 0 } }}
          disabled={disabled}
          helperText={t(`duration_units.${name}`)}
          placeholder=""
        />
      ))}
    </div>
  );
};

export default DurationFilter;
